import styles from './gradient-title.module.css';
import clsx from 'clsx';

interface GradientTitleProps {
  children: React.ReactNode;
  className?: string;
}

export function GradientTitle({ children, className }: GradientTitleProps) {
  return <div className={clsx(styles.titleContainer, className)}>{children}</div>;
}
